import { render } from "./ServiceTranslationEditing.vue?vue&type=template&id=0a733d6e"
import script from "./ServiceTranslationEditing.vue?vue&type=script&lang=js"
export * from "./ServiceTranslationEditing.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__